import axios from '../../../axios';
import IStripeClientSecretPayload from '../types/IStripeClientSecretPayload';
import IStripeInvoicePayload from '../types/IStripeInvoicePayload';
import IStripeRecharge from '../types/IStripeRecharge';

const url = 'api';

export const getStripeClientSecret = (payload: IStripeClientSecretPayload) =>
  axios.post(`${url}/get-client-secret`, payload);

export const verifyCoupon = (coupon: string) => axios.get(`${url}/verify-coupon/${coupon}`);

export const getCoupons = () => axios.get(`${url}/coupons`);

export const getAllProducts = () => axios.get(`${url}/products`);

export const getCustomPlanPricing = () => axios.get(`${url}/custom-plan/pricing`);

export const manageSelectedUsers = (payload: IStripeClientSecretPayload) =>
  axios.post(`${url}/manage-user`, payload);

export const getSubProrateCharges = (payload: IStripeClientSecretPayload) =>
  axios.post(`${url}/calculate/prorate-charges`, payload);

export const getNextPaymentInfo = () => axios.get(`${url}/next-payment/info`);

export const getStripeInvoices = (payload: IStripeInvoicePayload) =>
  axios.post(`${url}/user/invoices`, payload);

export const getClientSecretForSMSCredits = (payload: IStripeClientSecretPayload) =>
  axios.post(`${url}/workspace/communication/credit/get-client-secret`, payload);

export const getStripeRechargeInvoices = (payload: IStripeRecharge) =>
  axios.post(`/communicationservice/api/stripe/recharge/invoices`, payload);

export const getStripeRechargeInvoiceById = (id: string) =>
  axios.get(`/communicationservice/api/stripe/recharge/invoice/${id}`);

export const updatePaymentMethodInStripe = () => axios.get(`${url}/update/payment/method`);
